import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserJourneyService } from '../_services/user-journey.service';
import { TutorialService } from '../_services/tutorial.service';
import { SettingsService } from '../_services/settings.service';
import { ModuleService } from '../_services/module.service';
import { ModuleEnum } from '../_utils/unums/module.enum';
import { UserAssessmentService } from '../_services/user-assessment.service';

@Injectable({
  providedIn: 'root'
})
export class PreTrainingGuard implements CanActivate {

  constructor(
    private userAssessmentService: UserAssessmentService,
    private router: Router,
    private userJourneyService: UserJourneyService,
    private tutorialService: TutorialService,
    private settingsService: SettingsService,
    private moduleService: ModuleService
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const module = route.params.module;
    const hasModulePreTraining = await this.moduleService.getModuleProperty(
      module,
      'defaultUserGrade'
    );

    const isVGFlowOrDemo = await this.tutorialService.isVGFlow() || await this.userJourneyService.isDemo();

    if (isVGFlowOrDemo) {
      return true;
    }
    const moduleSettings = await this.settingsService.getModuleSettings(module);

    if (moduleSettings?.defaultUserGrade) {
      return true;
    }
    if (hasModulePreTraining) {
      this.router.navigate([route.params.module, 'courses']).then();
      return false;
    }
    const hasPretraining = await this.userAssessmentService.hasPreTraining(route.params.module);
    if (!hasPretraining) {
      this.router.navigate([route.params.module, 'courses']).then();
      return false;
    }
    return true;
  }

}
